import { useCallback } from 'react'

import { CARE_ADVISOR_TRUNK_PHONE_NUMBER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { openUrl } from '../utils/expo-linking'

export const useContactCareNavigatorByPhone = ({
  isLoggedIn,
  isInternational,
  customerPhoneNumber,
  openPhoneDirectory,
  onPressPhoneCallTrack,
}: {
  isLoggedIn: boolean
  isInternational: boolean
  customerPhoneNumber?: string
  openPhoneDirectory: () => void
  onPressPhoneCallTrack?: () => void
}) => {
  return useCallback(() => {
    onPressPhoneCallTrack && onPressPhoneCallTrack()
    if (isInternational || !isLoggedIn) {
      openPhoneDirectory()
      return
    }
    openUrl(`tel:${customerPhoneNumber || CARE_ADVISOR_TRUNK_PHONE_NUMBER}`)
  }, [customerPhoneNumber, isInternational, isLoggedIn, openPhoneDirectory, onPressPhoneCallTrack])
}
